import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getAlumniRefresh = ({ lastQueryTime }) =>
  httpClient.get(apis.getAlumniRefresh(), {
    params: { lastQueryTime },
    ignore: true,
    ignoreLoading: true,
  });

export const makeAlumniBless = (payload) =>
  httpClient.post(apis.makeAlumniBless(), payload, { ignore: true });
